/**
 * Boxful Physical AI tech page - mock telemetry dataset library
 * Source design: boxful_app 2/tech/ (static mockup)
 */

// Sample Telemetry & Multimodal Dataset Mock Library
const TASK_DATASETS = {
  task1: {
    name: "유리병 집기 & 에어캡 완충재 포장",
    sku: "SKU-GLASS-B082",
    category: "Fragile / Glass",
    duration: "1.82s",
    fps: "100Hz",
    status: "WMS Verified (SUCCESS)",
    timestamp: "2026-08-19T10:14:22.408Z",
    location: "Rack B-12-04 -> Tote-82",
    pressures: {
      thumb: 88,
      index: 82,
      middle: 75,
      ring: 40,
      palm: 30
    },
    pressureVals: {
      thumb: "4.8 N",
      index: "4.2 N",
      middle: "3.6 N",
      ring: "1.5 N",
      palm: "1.2 N"
    },
    jsonPreview: {
      task_id: "TASK-BOXFUL-2026-0819-01",
      domain: "logistics_fulfillment",
      sku: {
        id: "SKU-GLASS-B082",
        name: "Premium Olive Oil 500ml",
        material: "Glass",
        weight_g: 520,
        fragility: "HIGH"
      },
      wms_event: {
        pick_location: "B-12-04",
        target_tote: "TOTE-82",
        operator_id: "OP-KR-042",
        verification: "BARCODE_SCANNED_OK"
      },
      action_trajectory: {
        sampling_rate_hz: 100,
        wrist_imu_6axis: "stream_available (182 frames)",
        finger_flex_angles_rad: [0.12, 0.85, 0.82, 0.41, 0.35],
        fsr_pressure_newtons: [4.8, 4.2, 3.6, 1.5, 1.2],
        stages: ["APPROACH", "CONTACT", "ADAPTIVE_GRIP", "TRANSFER", "RELEASE"]
      },
      quality_metrics: {
        slip_detected: false,
        drop_detected: false,
        imitation_learning_readiness: 0.994
      }
    }
  },
  task2: {
    name: "연질 파우치 비정형 피킹 & 합포장",
    sku: "SKU-POUCH-P310",
    category: "Deformable / Pouch",
    duration: "1.45s",
    fps: "100Hz",
    status: "WMS Verified (SUCCESS)",
    timestamp: "2026-08-19T10:15:04.112Z",
    location: "Rack A-03-11 -> PackBox-03",
    pressures: {
      thumb: 65,
      index: 70,
      middle: 68,
      ring: 60,
      palm: 55
    },
    pressureVals: {
      thumb: "3.1 N",
      index: "3.4 N",
      middle: "3.2 N",
      ring: "2.8 N",
      palm: "2.5 N"
    },
    jsonPreview: {
      task_id: "TASK-BOXFUL-2026-0819-02",
      domain: "logistics_fulfillment",
      sku: {
        id: "SKU-POUCH-P310",
        name: "Refill Shampoo 800ml (Pouch)",
        material: "Flexible Plastic Pouch",
        weight_g: 820,
        deformable: true
      },
      wms_event: {
        pick_location: "A-03-11",
        target_tote: "PACKBOX-03",
        operator_id: "OP-KR-042",
        verification: "BARCODE_SCANNED_OK"
      },
      action_trajectory: {
        sampling_rate_hz: 100,
        wrist_imu_6axis: "stream_available (145 frames)",
        finger_flex_angles_rad: [0.35, 0.92, 0.90, 0.85, 0.70],
        fsr_pressure_newtons: [3.1, 3.4, 3.2, 2.8, 2.5],
        stages: ["APPROACH", "CONTOUR_ADAPTATION", "SURFACE_GRIP", "INSERTION", "RELEASE"]
      },
      quality_metrics: {
        slip_detected: false,
        liquid_center_of_mass_adapted: true,
        imitation_learning_readiness: 0.988
      }
    }
  },
  task3: {
    name: "중량 소형 택배박스 정밀 핏팅 & 투입",
    sku: "SKU-BOX-S044",
    category: "Rigid Box / Heavy",
    duration: "2.10s",
    fps: "100Hz",
    status: "WMS Verified (SUCCESS)",
    timestamp: "2026-08-19T10:16:30.985Z",
    location: "Conveyor Line 2 -> Outbound-Pallet",
    pressures: {
      thumb: 95,
      index: 90,
      middle: 92,
      ring: 85,
      palm: 80
    },
    pressureVals: {
      thumb: "6.2 N",
      index: "5.8 N",
      middle: "6.0 N",
      ring: "5.1 N",
      palm: "4.9 N"
    },
    jsonPreview: {
      task_id: "TASK-BOXFUL-2026-0819-03",
      domain: "logistics_fulfillment",
      sku: {
        id: "SKU-BOX-S044",
        name: "Skincare Set Gift Box",
        material: "Rigid Cardboard",
        weight_g: 1450,
        fragility: "MEDIUM"
      },
      wms_event: {
        pick_location: "LINE-2-PACK",
        target_tote: "PALLET-OUT-01",
        operator_id: "OP-KR-018",
        verification: "WMS_PACK_COMPLETED"
      },
      action_trajectory: {
        sampling_rate_hz: 100,
        wrist_imu_6axis: "stream_available (210 frames)",
        finger_flex_angles_rad: [0.15, 0.45, 0.46, 0.42, 0.38],
        fsr_pressure_newtons: [6.2, 5.8, 6.0, 5.1, 4.9],
        stages: ["APPROACH", "TWO_HAND_BALANCED_GRIP", "TRANSFER", "STACKING", "RELEASE"]
      },
      quality_metrics: {
        corner_impact_avoided: true,
        imitation_learning_readiness: 0.997
      }
    }
  }
};
